import { CourseriddenService } from './../../Services/courseridden.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-year-overview',
  template: require('./year-overview.component.html'),
  styles: [require('./year-overview.component.css')]
})
export class YearOverviewComponent implements OnInit {
  coursesRiddenGroup: any[] = [];
  countRidden: number = 0;
  countMembers: number = 0;
  countDistance: number = 0;
  avgMembersPerRide: number = 0;
  currentYear = new Date().getFullYear();
  allYears:number[] = []

  constructor(private courseRiddenService: CourseriddenService) { }

  ngOnInit() {

    this.courseRiddenService.getAllYears().subscribe( res => {
      this.allYears = res.reverse();
    });

    this.getData()
    
  }

  yearSelected(){
    // console.log("year change");
    // console.log(this.currentYear);
    this.getData();
  }

  private getData(){
    this.reset();
    this.courseRiddenService.getYearOverviewYear(this.currentYear).subscribe(x => {
      this.coursesRiddenGroup = x;
      this.doCalculations();
      // console.log(this.coursesRiddenGroup);
    });
  }

  private reset(){
    this.countRidden = 0;
    this.countMembers = 0;
    this.countDistance = 0;
}

  private doCalculations() {
    this.coursesRiddenGroup.forEach(element => {
      this.countRidden += element.countRidden;
      this.countMembers += element.countMembers;
      this.countDistance += element.sumDistance;
    })
    this.avgMembersPerRide = this.countMembers / this.countRidden;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/year-overview/year-overview.component.ts